import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Link } from 'react-router-dom';
import { FeatureShowcase, FeatureShowcaseTextContainer } from './featureShowcase/featureShowcase';
import { LARGE_FEATURE_SHOWCASE_TEXT_CSS, MEDIUM_FEATURE_SHOWCASE_TEXT_CSS } from './featureShowcase/featureShowcaseStyles';
const FEATURES_COLUMN_CONTAINER_CSS = css `
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const FEATURES_COLUMN_CSS = css `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  max-width: 600px;
`;
const TRIPLEJACK_POKER_TEXT_CSS = css `
  color: white;
  font-size: 125%;
`;
export const StaticEntryColumnContent = () => {
    return (_jsx("div", { css: FEATURES_COLUMN_CONTAINER_CSS, children: _jsxs("div", { css: FEATURES_COLUMN_CSS, children: [_jsxs(FeatureShowcaseTextContainer, { children: [_jsxs("div", { css: LARGE_FEATURE_SHOWCASE_TEXT_CSS, children: [_jsx("span", { css: TRIPLEJACK_POKER_TEXT_CSS, children: "Triplejack Poker" }), " is a free-to-play, non-gambling game!*"] }), _jsxs("div", { css: MEDIUM_FEATURE_SHOWCASE_TEXT_CSS, children: ["Built for the modern web \uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDCBB\uD83C\uDF0E and ", _jsx(Link, { to: '/guide/mobile-device-support', children: "mobile devices" }), "! \uD83D\uDCF1"] })] }), _jsx(FeatureShowcase, {})] }) }));
};
